// Fetch the JSON data
// const jsonUrl = "{{ section.settings.data_file_url }}"; // Replace with actual URL to the JSON file
fetch(jsonUrl)
  .then((response) => response.json())
  .then((data) => {
    populateManufacturers(data);
  })
  .catch((error) => console.error("Error fetching JSON:", error));

// Populate Manufacturers
function populateManufacturers(data) {
  const manufacturerDropdown = document.getElementById("boat-manufacturer-selector");

  const manufacturers = [...new Set(data.map((item) => item.Manufacturer))];
  manufacturers.forEach((manufacturer) => {
    const option = document.createElement("option");
    option.value = manufacturer;
    option.textContent = manufacturer;
    manufacturerDropdown.appendChild(option);
  });

  manufacturerDropdown.addEventListener("change", function () {
    const selectedManufacturer = this.value;
    populateModels(data, selectedManufacturer);
  });
}

// Populate Models
function populateModels(data, manufacturer) {
  const modelDropdown = document.getElementById("boat-model-selector");
  modelDropdown.innerHTML = '<option value="">Select Model</option>'; // Reset the dropdown
  modelDropdown.disabled = false;

  const models = data
    .filter((item) => item.Manufacturer === manufacturer)
    .map((item) => item.Model);

  [...new Set(models)].forEach((model) => {
    const option = document.createElement("option");
    option.value = model;
    option.textContent = model;
    modelDropdown.appendChild(option);
  });

  modelDropdown.addEventListener("change", function () {
    const selectedModel = this.value;
    populateMaterials(data, manufacturer, selectedModel);
  });
}

// Populate Materials
function populateMaterials(data, manufacturer, model) {
  const materialDropdown = document.getElementById("spray-skirt-material-selector");
  materialDropdown.innerHTML = '<option value="">Choose Material</option>';
  materialDropdown.disabled = false;

  const materials = data
    .filter((item) => item.Manufacturer === manufacturer && item.Model === model)
    .map((item) => item.Material);

  [...new Set(materials)].forEach((material) => {
    const option = document.createElement("option");
    option.value = material;
    option.textContent = material;
    materialDropdown.appendChild(option);
  });

  materialDropdown.addEventListener("change", function () {
    const selectedMaterial = this.value;
    populateSkirtModels(data, manufacturer, model, selectedMaterial);
  });
}

// Populate Skirt Models
function populateSkirtModels(data, manufacturer, model, material) {
  const skirtModelDropdown = document.getElementById("spray-skirt-model-selector");
  skirtModelDropdown.innerHTML = '<option value="">Choose Model</option>';
  skirtModelDropdown.disabled = false;

  const skirtModels = data
    .filter((item) => item.Manufacturer === manufacturer && item.Model === model && item.Material === material)
    .map((item) => item.SkirtModel);

  [...new Set(skirtModels)].forEach((skirtModel) => {
    const option = document.createElement("option");
    option.value = skirtModel;
    option.textContent = skirtModel;
    skirtModelDropdown.appendChild(option);
  });

  skirtModelDropdown.addEventListener("change", function () {
    const selectedSkirtModel = this.value;
    populateSkirtSizes(data, manufacturer, model, material, selectedSkirtModel);
  });
}

// Populate Skirt Sizes
function populateSkirtSizes(data, manufacturer, model, material, skirtModel) {
  const skirtSizeDropdown = document.getElementById("skirt-size-selector");
  skirtSizeDropdown.innerHTML = '<option value="">Click To See Size</option>';
  skirtSizeDropdown.disabled = false;

  const skirtSizes = data
    .filter((item) => item.Manufacturer === manufacturer && item.Model === model && item.Material === material && item.SkirtModel === skirtModel)
    .map((item) => item.Size);

  [...new Set(skirtSizes)].forEach((size) => {
    const option = document.createElement("option");
    option.value = size;
    option.textContent = size;
    skirtSizeDropdown.appendChild(option);
  });
}

// Add event listener for the "Find Products" button
document.getElementById("fetch-product-btn").addEventListener("click", function () {
  const manufacturer = document.getElementById("boat-manufacturer-selector").value;
  const model = document.getElementById("boat-model-selector").value;
  const material = document.getElementById("spray-skirt-material-selector").value;
  const skirtModel = document.getElementById("spray-skirt-model-selector").value;
  const size = document.getElementById("skirt-size-selector").value;

  // Find matching product link
  fetch(jsonUrl)
    .then((response) => response.json())
    .then((data) => {
      const product = data.find((item) => 
        item.Manufacturer === manufacturer &&
        item.Model === model &&
        item.Material === material &&
        item.SkirtModel === skirtModel &&
        item.Size === size
      );

      if (product && product.Link) {
        window.open(product.Link, "_blank"); // Open the product link in a new tab

        // Clear the form fields
        document.getElementById("size-selector-form").reset();
        disableAllDropdowns(); // Optional: Reset dropdowns to disabled state
      } else {
        noProductsAvailable()
      }
    })
    .catch((error) => console.error("Error fetching product data:", error));
});

// Function to disable dropdowns after resetting
function disableAllDropdowns() {
  document.getElementById("boat-model-selector").disabled = true;
  document.getElementById("spray-skirt-material-selector").disabled = true;
  document.getElementById("spray-skirt-model-selector").disabled = true;
  document.getElementById("skirt-size-selector").disabled = true;
}
// Check the product is not avalaible.
function noProductsAvailable() {
  const bannerHolder =   document.querySelector(".no-product");
  bannerHolder.style.display = 'block';
  
}
const noProductsAvailableTimeout = setInterval(()=>{
   const bannerHolder =   document.querySelector(".no-product");
  bannerHolder.style.display = 'none';
}, 10000)
